<template>
  <div class="mailtemplates-page">
    <div class="page-head">
      <div class="left">
        <h1>Manage message templates</h1>
      </div>
    </div>
    <MailTemplatesForm ref="MailTemplatesForm"></MailTemplatesForm>
  </div>
</template>

<script>
import MailTemplatesForm from "@/components/MailTemplates/MailTemplatesForm";
export default {
  name: "MailTemplates",
  components: {
    MailTemplatesForm
  },
  methods: {},
  mounted() {}
};
</script>
